import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Machine} from "../model/machine";
import {Firmware} from "../model/firmware";
import {FirmwareRequest} from "../model/requests/firmware-request";
import {FirmwareProcedureFilters} from "../model/filters/firmware-procedure-filters";
import {HttpUtils} from "../shared/http.utils";
import {FiltersUtils} from "../shared/filters.utils";

@Injectable({
  providedIn: 'root'
})
export class FirmwareService {

  private readonly firmwareURL: string;


  constructor(private http: HttpClient) {
    this.firmwareURL = '/api/firmware';
  }

  public getFirmwares(): Observable<{ firmwares: Firmware[] }> {
    return this.http.get<{ firmwares: Firmware[] }>(this.firmwareURL);
  }

  public getMachinesFirmware(): Observable<{ machines: Machine[] }> {
    const url: string = `${this.firmwareURL}/machines`;
    return this.http.get<{ machines: Machine[] }>(url);
  }

  public getFirmwareProcedures(offset?: number, limit?: number, filters?: FirmwareProcedureFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    if (filters != null) {
      options.params["serialNumber"] = FiltersUtils.getFilterTrim(filters.serialNumber);
      options.params["firmwareTypes"] = FiltersUtils.getFilter(filters.firmwareTypes);
      options.params["targetVersion"] = FiltersUtils.getFilterTrim(filters.targetVersion);
      options.params["states"] = FiltersUtils.getFilter(filters.states);
      options.params["from"] = FiltersUtils.getFilter(filters.from);
      options.params["until"] = FiltersUtils.getFilter(filters.until);
      options.params["organizationUuids"] = FiltersUtils.getFilter(filters.organizationUuids);
      options.params["sortField"] = FiltersUtils.getFilter(filters.sortField);
      options.params["sortOrder"] = FiltersUtils.getFilter(filters.sortOrder);
    }
    const url: string = `${this.firmwareURL}/procedures`;
    return this.http.get<any>(url, options);
  }

  public updateFirmware(firmwareRequest: FirmwareRequest): Observable<any> {
    return this.http.put<any>(this.firmwareURL, firmwareRequest);
  }

}
